(function () {
  function setMeetAppIndexes(section) {
    var imageLists = section.querySelectorAll('.meet-app__image-list');
    imageLists.forEach(function (ul) {
      var index = 1;
      ul.querySelectorAll('li').forEach(function (li) {
        if (!li.querySelector('img')) return;
        li.setAttribute('data-section-image', String(index));
        index += 1;
      });
    });

    section.querySelectorAll('.meet-app__content-cards').forEach(function (wrapper) {
      var index = 1;
      wrapper.querySelectorAll('.meet-app__inndercontentblock').forEach(function (el) {
        el.setAttribute('data-section-id', String(index));
        index += 1;
      });
    });
  }

  function MeetAppScroll(section) {
    this.section = section;
    this.contentBlocks = Array.from(
      section.querySelectorAll('.meet-app__inndercontentblock[data-section-id]')
    );
    this.imageItems = Array.from(
      section.querySelectorAll('.meet-app__image-list li[data-section-image]')
    );
    this.imageList = section.querySelector('.meet-app__image-list');
    this.indicator = section.querySelector('.meet-app__indicatorblock');
    this.lineWrapper = section.querySelector('.meet-app__line-wrapper');
    this.contentWrapper = section.querySelector('.meet-app__contentwrapper');
    this.ticking = false;
  }

  MeetAppScroll.prototype.syncLineHeight = function () {
    var line = this.section.querySelector('.meet-app__line');
    if (!this.lineWrapper || !this.contentWrapper) return;
    var height = this.contentWrapper.offsetHeight;
    this.lineWrapper.style.height = height + 'px';
    if (line) line.style.minHeight = height + 'px';
  };

  MeetAppScroll.prototype.getActiveId = function () {
    if (!this.contentBlocks.length) return '1';

    var viewportCenter = window.innerHeight * 0.5;
    var activeId = this.contentBlocks[0].dataset.sectionId;
    var minDistance = Infinity;

    this.contentBlocks.forEach(function (block) {
      var rect = block.getBoundingClientRect();
      var blockCenter = rect.top + rect.height * 0.5;
      var distance = Math.abs(blockCenter - viewportCenter); 
      if (distance < minDistance) {
        minDistance = distance;
        activeId = block.dataset.sectionId;
      }
    });

    return activeId;
  };

  MeetAppScroll.prototype.syncHeaderOffset = function () {
    var headerHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );

    if (!headerHeight || isNaN(headerHeight)) {
      var headerEl = document.querySelector(
        '.shopify-section-header-sticky, sticky-header, .header-wrapper'
      );
      headerHeight = headerEl ? headerEl.offsetHeight : 100;
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    }

    var gap = 16;
    this.section.style.setProperty('--meet-app-header-offset', headerHeight + 'px');
    this.section.style.setProperty(
      '--meet-app-sticky-top-fallback',
      headerHeight + gap + 'px'
    );
  };

  MeetAppScroll.prototype.setActive = function (activeId) {
    this.section.dataset.meetAppActive = activeId;
    this.syncHeaderOffset();

    this.contentBlocks.forEach(function (block) {
      var isActive = block.dataset.sectionId === activeId;
      block.classList.toggle('is-active', isActive);
      block.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this.imageItems.forEach(function (li) {
      var isActive = li.dataset.sectionImage === activeId; 
      li.classList.toggle('is-active', isActive);
      li.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    this.updateIndicatorPosition();
  };

  MeetAppScroll.prototype.updateIndicatorPosition = function () {
    if (!this.indicator || !this.lineWrapper) return;

    var lineRect = this.lineWrapper.getBoundingClientRect();
    var indicatorHeight = this.indicator.offsetHeight;
    var maxTravel = Math.max(0, this.lineWrapper.offsetHeight - indicatorHeight);
    var viewportCenter = window.innerHeight * 0.5;
    var top = viewportCenter - lineRect.top - indicatorHeight * 0.5;

    top = Math.max(0, Math.min(maxTravel, top));
    this.indicator.style.transform = 'translate3d(-50%, ' + top + 'px, 0)';
  };

  MeetAppScroll.prototype.update = function () {
    this.setActive(this.getActiveId());
    this.ticking = false;
  };

  MeetAppScroll.prototype.onScroll = function () {
    if (!this.ticking) {
      this.ticking = true;
      window.requestAnimationFrame(this.update.bind(this));
    }
  };

  MeetAppScroll.prototype.init = function () {
    var self = this;
    setMeetAppIndexes(this.section);

    if (!this.contentBlocks.length) return;

    this.syncHeaderOffset();
    this.syncLineHeight();
    this.setActive(this.getActiveId());

    this._onScroll = function () {
      self.onScroll();
    };
    this._onResize = function () {
      self.syncHeaderOffset();
      self.syncLineHeight();
      self.update();
    };

    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });
    window.addEventListener('load', function () {
      self.syncHeaderOffset();
      self.syncLineHeight();
      self.updateIndicatorPosition();
    });

    setTimeout(function () {
      self.syncHeaderOffset();
      self.syncLineHeight();
      self.updateIndicatorPosition(); 
    }, 300);

    if (window.ResizeObserver && this.contentWrapper) {
      this._resizeObserver = new ResizeObserver(function () {
        self.syncLineHeight();
        self.updateIndicatorPosition();
      });
      this._resizeObserver.observe(this.contentWrapper);
    }
  };

  function initMeetAppSections(root) {
    (root || document).querySelectorAll('.meet-app__sec').forEach(function (section) {
      if (section._meetAppScroll) return;
      var instance = new MeetAppScroll(section);
      instance.init();
      section._meetAppScroll = instance;
    });
  }

  initMeetAppSections();

  document.addEventListener('shopify:section:load', function (event) {
    initMeetAppSections(event.target);
  });
})();
